import { createSessionExpirableStorageProvider } from '@jira/platform__browser-storage-providers/src/controllers/session-storage/index.tsx';
import { type SessionStorage, PERSIST_KEY } from './SessionStorage.tsx';

const crossProjectBoardTraitSessionProvider = createSessionExpirableStorageProvider(PERSIST_KEY);

export const crossProjectBoardTraitSessionStorageProvider = (): {
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	get: () => any;
	persist: (toPersist: SessionStorage) => void;
} => {
	const persist = (toPersist: SessionStorage): void => {
		// @browser-storage setter
		crossProjectBoardTraitSessionProvider.set(PERSIST_KEY, toPersist);
	};

	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	const get = (): any => crossProjectBoardTraitSessionProvider.get(PERSIST_KEY);

	return { get, persist };
};
